"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenuSeparator = exports.DropdownMenuItem = exports.DropdownMenuContent = exports.DropdownMenuTrigger = exports.DropdownMenu = void 0;
const DropdownMenuPrimitive = __importStar(require("@radix-ui/react-dropdown-menu"));
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../lib/utils");
const DropdownMenu = DropdownMenuPrimitive.Root;
exports.DropdownMenu = DropdownMenu;
const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
exports.DropdownMenuTrigger = DropdownMenuTrigger;
const dropdownMenuContentDefaultStyles = "tw-shadow-dropdown tw-z-50 tw-min-w-32 tw-overflow-hidden tw-rounded-md tw-bg-neutral-25 tw-py-2";
const dropdownMenuContentAnimationStyles = "data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2";
const DropdownMenuContent = react_1.default.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (react_1.default.createElement(DropdownMenuPrimitive.Portal, null,
    react_1.default.createElement(DropdownMenuPrimitive.Content, { ref: ref, sideOffset: sideOffset, className: (0, utils_1.cn)([dropdownMenuContentDefaultStyles, dropdownMenuContentAnimationStyles], className), ...props }))));
exports.DropdownMenuContent = DropdownMenuContent;
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
const dropdownMenuItemDefaultStyles = "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-4 tw-py-1 tw-outline-none tw-transition-colors";
const dropdownMenuItemFontStyles = "tw-text-sm tw-font-semibold tw-text-neutral-500";
const dropdownMenuItemFocusStyles = "focus:tw-bg-primary-25 focus:tw-text-primary-300";
const dropdownMenuItemDisabledStyles = "data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50";
const DropdownMenuItem = react_1.default.forwardRef(({ className, inset, ...props }, ref) => (react_1.default.createElement(DropdownMenuPrimitive.Item, { ref: ref, className: (0, utils_1.cn)([
        dropdownMenuItemDefaultStyles,
        dropdownMenuItemFontStyles,
        dropdownMenuItemFocusStyles,
        dropdownMenuItemDisabledStyles,
    ], inset && "pl-8", className), ...props })));
exports.DropdownMenuItem = DropdownMenuItem;
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
const dropdownMenuSeparatorStyles = "-tw-mx-1 tw-my-2 tw-h-px tw-bg-neutral-100";
const DropdownMenuSeparator = react_1.default.forwardRef(({ className, ...props }, ref) => (react_1.default.createElement(DropdownMenuPrimitive.Separator, { ref: ref, className: (0, utils_1.cn)(dropdownMenuSeparatorStyles, className), ...props })));
exports.DropdownMenuSeparator = DropdownMenuSeparator;
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
